document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-product-personalizer-hochzeit]');
  if (!root) return;

  const openBtns = document.querySelectorAll('[data-personalizer-open-hochzeit]');
  const modal = root.querySelector('[data-personalizer-modal]');
  const closeBtns = root.querySelectorAll('[data-personalizer-close]');
  const nextBtn = root.querySelector('[data-next-step]');
  const prevBtns = root.querySelectorAll('[data-prev-step]');
  const submitBtn = root.querySelector('[data-submit-personalizer]');
  const steps = root.querySelectorAll('[data-step]');
  const progressItems = root.querySelectorAll('[data-progress-step]');
  const physicalOnlyWrap = root.querySelector('[data-physical-only]');
  const exampleOpenBtn = root.querySelector('[data-open-example-player]');
  const exampleModal = root.querySelector('[data-example-modal]');
  const exampleCloseBtns = root.querySelectorAll('[data-close-example-player]');
  const stepTitle = root.querySelector('[data-step-title]');
  const errorStep1 = root.querySelector('[data-error-step="1"]');
  const errorStep2 = root.querySelector('[data-error-step="2"]');
  const detailsField = root.querySelector('[data-field="details"]');
  const detailsCounter = root.querySelector('[data-details-counter]');
  const recipientField = root.querySelector('[data-field="recipient"]');
  const recipientCounter = root.querySelector('[data-recipient-counter]');
  const pronunciationField = root.querySelector('[data-field="pronunciation"]');
  const pronunciationCounter = root.querySelector('[data-pronunciation-counter]');
  const weddingDateWrap = root.querySelector('[data-wedding-date-wrap]');

  const mainVariantId = root.dataset.mainVariantId;
  const cdVariantId = root.dataset.cdVariantId;
  const usbVariantId = root.dataset.usbVariantId;
  const giftWrapVariantId = root.dataset.giftWrapVariantId;
  const giftCardVariantId = root.dataset.giftCardVariantId;
  const rush48VariantId = root.dataset.rush48VariantId;
  const rush24VariantId = root.dataset.rush24VariantId;
  const lyricsPdfVariantId = root.dataset.lyricsPdfVariantId;

  const state = {
    currentStep: 1,
    perspective: '',
    recipient: '',
    mentionWeddingDate: 'no',
    weddingDate: '',
    details: '',
    style: '',
    voice: '',
    pronunciation: '',
    deliveryType: 'download',
    giftWrap: 'no',
    giftCard: 'no',
    processingTime: '3 Tage',
    lyricsPdf: 'no'
  };

  let popupPlayerInitialized = false;
  let scrollY = 0;
  let bodyWasLocked = false;

  function lockBodyScroll() {
    if (bodyWasLocked) return;

    scrollY = window.scrollY || window.pageYOffset || 0;
    bodyWasLocked = true;

    document.body.classList.add('personalizer-modal-open');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockBodyScroll() {
    if (!bodyWasLocked) return;

    bodyWasLocked = false;

    document.body.classList.remove('personalizer-modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    window.scrollTo(0, scrollY);
  }

  function getCurrentErrorBox() {
    if (state.currentStep === 2) return errorStep2;
    return errorStep1;
  }

  function showError(message) {
    hideError();
    const box = getCurrentErrorBox();
    if (!box) return;
    box.textContent = message;
    box.hidden = false;
  }

  function hideError() {
    [errorStep1, errorStep2].forEach((box) => {
      if (!box) return;
      box.hidden = true;
      box.textContent = '';
    });
  }

  function updateDetailsCounter() {
    if (!detailsField || !detailsCounter) return;
    detailsCounter.textContent = `${detailsField.value.length}/1000`;
  }

  function updateRecipientCounter() {
    if (!recipientField || !recipientCounter) return;
    recipientCounter.textContent = `${recipientField.value.length}/50`;
  }

  function updatePronunciationCounter() {
    if (!pronunciationField || !pronunciationCounter) return;
    pronunciationCounter.textContent = `${pronunciationField.value.length}/170`;
  }

  function updateStepTitle(stepNumber) {
    if (!stepTitle) return;
    if (stepNumber === 1) stepTitle.textContent = 'Song Personalisierung';
    if (stepNumber === 2) stepTitle.textContent = 'Zubehör';
    if (stepNumber === 3) stepTitle.textContent = 'Fertig';
  }

  function showStep(stepNumber) {
    steps.forEach((step) => {
      step.hidden = Number(step.dataset.step) !== stepNumber;
    });

    progressItems.forEach((item) => {
      const isActive = Number(item.dataset.progressStep) === stepNumber;
      item.classList.toggle('is-active', isActive);
    });

    state.currentStep = stepNumber;
    updateStepTitle(stepNumber);
    hideError();

    const dialog = root.querySelector('.product-personalizer__dialog');
    if (dialog) dialog.scrollTop = 0;
  }

  function openModal() {
    lockBodyScroll();
    modal.hidden = false;
    showStep(1);
  }

  function closeModal() {
    closeExampleModal();
    modal.hidden = true;
    unlockBodyScroll();
  }

  function updateWeddingDateVisibility() {
    const mentionWeddingDateInput = root.querySelector('[data-field="mentionWeddingDate"]:checked');
    const show = mentionWeddingDateInput && mentionWeddingDateInput.value === 'yes';
    if (weddingDateWrap) weddingDateWrap.hidden = !show;
  }

  function updatePhysicalVisibility() {
    const deliveryInput = root.querySelector('[data-field="deliveryType"]:checked');
    const isPhysical = deliveryInput && (deliveryInput.value === 'cd' || deliveryInput.value === 'usb');
    if (physicalOnlyWrap) physicalOnlyWrap.hidden = !isPhysical;
  }

  function updateCardStates() {
    root.querySelectorAll('[data-card]').forEach((card) => {
      const input = card.querySelector('input[type="radio"]');
      if (!input) return;

      card.classList.toggle('is-selected', input.checked);

      const button = card.querySelector('.product-personalizer__select-button');
      if (button) {
        button.textContent = input.checked ? 'Ausgewählt' : 'Auswählen';
      }
    });
  }

  function addCalendarDays(startDate, days) {
    const date = new Date(startDate);
    date.setDate(date.getDate() + days);
    return date;
  }

  function formatGermanDate(date) {
    return new Intl.DateTimeFormat('de-DE', {
      weekday: 'long',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(date);
  }

  function formatGermanTime(date) {
    return new Intl.DateTimeFormat('de-DE', {
      hour: '2-digit',
      minute: '2-digit'
    }).format(date);
  }

  function renderDeliveryDates() {
    root.querySelectorAll('[data-delivery-label]').forEach((node) => {
      const label = node.dataset.deliveryLabel;
      const now = new Date();
      let line2 = '';

      if (label === '3 Tage') {
        const date = addCalendarDays(now, 3);
        line2 = formatGermanDate(date);
      }

      if (label === '48 Stunden') {
        const date = new Date(now.getTime() + 48 * 60 * 60 * 1000);
        line2 = `${formatGermanDate(date)}, ${formatGermanTime(date)} Uhr`;
      }

      if (label === '24 Stunden') {
        const date = new Date(now.getTime() + 24 * 60 * 60 * 1000);
        line2 = `${formatGermanDate(date)}, ${formatGermanTime(date)} Uhr`;
      }

      node.textContent = `Du erhältst dein Lied bis:\n${line2}`;
    });
  }

  function collectStep1() {
    state.perspective = root.querySelector('[data-field="perspective"]')?.value || '';
    state.recipient = root.querySelector('[data-field="recipient"]')?.value.trim() || '';
    state.mentionWeddingDate = root.querySelector('[data-field="mentionWeddingDate"]:checked')?.value || 'no';
    state.weddingDate = root.querySelector('[data-field="weddingDate"]')?.value || '';
    state.details = root.querySelector('[data-field="details"]')?.value.trim() || '';
    state.style = root.querySelector('[data-field="style"]')?.value || '';
    state.voice = root.querySelector('[data-field="voice"]')?.value || '';
    state.pronunciation = root.querySelector('[data-field="pronunciation"]')?.value.trim() || '';

    if (!state.perspective) {
      showError('Bitte wähle eine Perspektive aus.');
      return false;
    }

    if (!state.recipient) {
      showError('Bitte trage ein, an wen das Lied gerichtet ist.');
      return false;
    }

    if (state.mentionWeddingDate === 'yes' && !state.weddingDate) {
      showError('Bitte wähle das Hochzeitsdatum aus.');
      return false;
    }

    if (!state.details) {
      showError('Bitte gib Details für den Song an.');
      return false;
    }

    if (!state.style) {
      showError('Bitte wähle eine Musikrichtung aus.');
      return false;
    }

    if (!state.voice) {
      showError('Bitte wähle eine Stimme aus.');
      return false;
    }

    return true;
  }

  function collectStep2() {
    state.deliveryType = root.querySelector('[data-field="deliveryType"]:checked')?.value || 'download';
    state.giftWrap = root.querySelector('[data-field="giftWrap"]:checked')?.value || 'no';
    state.giftCard = root.querySelector('[data-field="giftCard"]:checked')?.value || 'no';
    state.processingTime = root.querySelector('[data-field="processingTime"]:checked')?.value || '3 Tage';
    state.lyricsPdf = root.querySelector('[data-field="lyricsPdf"]:checked')?.value || 'no';
  }

  function buildMainProductProperties(bundleId) {
    return {
      'Perspektive': state.perspective,
      'Gerichtet an': state.recipient,
      'Hochzeitsdatum erwähnen': state.mentionWeddingDate === 'yes' ? 'Ja' : 'Nein',
      'Hochzeitsdatum': state.mentionWeddingDate === 'yes' ? state.weddingDate : '',
      'Song-Details': state.details,
      'Musikrichtung': state.style,
      'Stimme': state.voice,
      'Aussprache / Wünsche': state.pronunciation,
      '_bundle_id': bundleId,
      '_bundle_role': 'main',
      '_bundle_order': '1'
    };
  }

  function buildChildProperties(bundleId, order) {
    return {
      '_bundle_id': bundleId,
      '_bundle_role': 'child',
      '_bundle_order': String(order)
    };
  }

  async function addItemsToCartAndGoToCart() {
    if (!mainVariantId) {
      showError('Keine Hauptvariante gefunden.');
      return;
    }

    const bundleId = `pp-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    let bundleOrder = 2;

    const items = [
      {
        id: Number(mainVariantId),
        quantity: 1,
        properties: buildMainProductProperties(bundleId)
      }
    ];

    if (state.deliveryType === 'cd' && cdVariantId) {
      items.push({
        id: Number(cdVariantId),
        quantity: 1,
        properties: buildChildProperties(bundleId, bundleOrder++)
      });
    }

    if (state.deliveryType === 'usb' && usbVariantId) {
      items.push({
        id: Number(usbVariantId),
        quantity: 1,
        properties: buildChildProperties(bundleId, bundleOrder++)
      });
    }

    if (state.deliveryType !== 'download' && state.giftWrap === 'yes' && giftWrapVariantId) {
      items.push({
        id: Number(giftWrapVariantId),
        quantity: 1,
        properties: buildChildProperties(bundleId, bundleOrder++)
      });
    }

    if (state.deliveryType !== 'download' && state.giftCard === 'yes' && giftCardVariantId) {
      items.push({
        id: Number(giftCardVariantId),
        quantity: 1,
        properties: buildChildProperties(bundleId, bundleOrder++)
      });
    }

    if (state.processingTime === '48 Stunden' && rush48VariantId) {
      items.push({
        id: Number(rush48VariantId),
        quantity: 1,
        properties: buildChildProperties(bundleId, bundleOrder++)
      });
    }

    if (state.processingTime === '24 Stunden' && rush24VariantId) {
      items.push({
        id: Number(rush24VariantId),
        quantity: 1,
        properties: buildChildProperties(bundleId, bundleOrder++)
      });
    }

    if (state.lyricsPdf === 'yes' && lyricsPdfVariantId) {
      items.push({
        id: Number(lyricsPdfVariantId),
        quantity: 1,
        properties: buildChildProperties(bundleId, bundleOrder++)
      });
    }

    submitBtn.disabled = true;

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        let message = 'Fehler beim Hinzufügen zum Warenkorb.';
        try {
          const errorData = await response.json();
          if (errorData.description) message = errorData.description;
        } catch (e) {}
        throw new Error(message);
      }

      progressItems.forEach((item) => item.classList.remove('is-active'));
      root.querySelector('[data-progress-step="3"]')?.classList.add('is-active');
      updateStepTitle(3);

      window.location.href = '/cart';
    } catch (error) {
      showError(error.message || 'Unbekannter Fehler.');
      submitBtn.disabled = false;
    }
  }

  function initExamplePlayer() {
    if (popupPlayerInitialized) return;
    if (!exampleModal) return;

    const playerRoot = exampleModal.querySelector('[data-xp-player]');
    if (!playerRoot) return;

    popupPlayerInitialized = true;

    const DATA = {
  'Ballade': [
    { title: 'Gemeinsam aufgebaut', artist: 'Ballade – männliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Ballade_m_Gemeinsam%20aufgebaut.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Ballade_m_Gemeinsam%20aufgebaut.jpg' },
    { title: 'Heute beginnt für immer', artist: 'Ballade – weibliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Ballade_f_Heute%20beginnt%20fuer%20immer.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Ballade_f_Heute%20beginnt%20fuer%20immer.jpg' },
    { title: 'Mitten im Leben', artist: 'Ballade – männliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Ballade_m_%20Mitten%20im%20Leben.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Ballade_m_Mitten%20im%20Leben.jpg' },
    { title: 'Unser Wunder beginnt', artist: 'Ballade – weibliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Ballade_f_Unser%20Wunder%20beginnt.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Ballade_f_Unser%20Wunder%20beginnt.jpg' }
  ],
  'Klassisch': [
    { title: 'Zweite Wege', artist: 'Schlager – weibliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Klassisch_f_Zweite%20Wege.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rap_f_Echt%20und%20loyal.jpg' },
    { title: 'Immer wieder Wir', artist: 'Klassisch – männliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Klassisch_m_Immer%20Wieder%20Wir.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rap_f_Unser%20neues%20Kapitel.jpg' },
    { title: 'Immer wieder Aufstehen', artist: 'Klassisch – weibliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Klassisch_f_%20Immer%20Wieder%20Aufstehen.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rap_m_Liebe%20mit%20Rueckgrat.jpg' },
    { title: 'Gemeinsam für Immer', artist: 'Klassisch – männliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Klassisch_m_Gemeinsam%20Fuer%20Immer.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rap_m_Unsere%20Verbindung.jpg' }
  ],
  'Akustik': [
    { title: 'Seit damals Wir', artist: 'Akustik – männliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Akustik_m_Seit%20damals%20Wir.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rock_f_Unser%20lautes%20wir.jpg' },
    { title: 'Was ich dir sagen will', artist: 'Akustik – weibliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Akustik_f_Was%20ich%20dir%20sagen%20will.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rock_m_Ein%20wahr%20gewordener%20Traum.jpg' },
    { title: 'Mehr als wir Zwei', artist: 'Akustik – männliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Akustik_m_Mehr%20als%20wir%20zwei.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rock_f_Heute%20ist%20unser%20Ja.jpg' },
    { title: 'Ich habe dich gewählt', artist: 'Akustik – weibliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Akustik_f_Ich%20hab%20dich%20gewa%CC%88hlt.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rock_m_Lautes%20Leben.jpg' }
  ],
  'Pop': [
    { title: 'Für immer wir Zwei', artist: 'Pop – männliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Pop_m_%20Fuer%20immer%20wir%20zwei.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Pop_m_Fuer%20immer%20wir%20zwei.jpg' },
    { title: 'Nie wieder getrennt', artist: 'Pop – weibliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Pop_f_%20Nie%20wieder%20getrennt.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Pop_f_Fuer%20immer%20wir%20zwei.jpg' },
    { title: 'Unsere Zeit', artist: 'Pop – männliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Pop_m_Unsere%20Zeit.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Pop_m_Unsere%20Zeit.jpg' },
    { title: 'Markus, für immer wir Beide', artist: 'Pop – weibliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Pop_f_Markus%20Fuer%20immer%20wir%20beide.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Pop_f_Fuer%20immer%20wir%20beide.jpg' }
  ],
  'Schlager': [
    { title: 'Gemeinsam für Immer', artist: 'Klassisch – männliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Klassisch_m_Gemeinsam%20Fuer%20Immer.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Schlager_m_Unser%20Weg%20ins%20Glueck.jpg' },
    { title: 'Heute sagen wir Ja', artist: 'Schlager – weibliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Schlager_f_%20Heute%20sagen%20wir%20Ja.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Schlager_f_Heute%20sagen%20wir%20Ja.jpg' },
    { title: 'Unser gemeinsamer Weg', artist: 'Schlager – männliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Schlager_m_Unser%20gemeinsamer%20Weg.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Schlager_m_Unser%20gemeinsamer%20Weg.jpg' },
    { title: 'Unser Weg um die Welt', artist: 'Schlager – weibliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Schlager_f_Unser%20Weg%20um%20die%20Welt.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Schlager_f_Unser%20Weg%20um%20die%20Welt.jpg' }
  ],
  'Andere': [
    { title: 'Lautes Wir', artist: 'Rock – weibliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rock_f_%20Lautes%20wir.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rock_Algemein%201.jpg' },
    { title: 'Ein wahr gewordener Traum', artist: 'Rock - männliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rock_m_Ein%20wahr%20gewordener%20Traum.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rock_Algemein%202.jpg' },
    { title: 'Unser neues Kapitel', artist: 'Rap - weibliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rap_f_%20Unser%20neues%20Kapitel.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rap_Algemein%201.jpg' },
    { title: 'Unsere Verbindung', artist: 'Rap - männliche Stimme', url: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rap_m_Unsere%20Verbindung.mp3', cover: 'https://Beispiellieder.b-cdn.net/Beispiellieder%20Hochzeit/Hochzeit_Rap_Algemein%202.jpg' }
  ]
};

    const PLACEHOLDER =
      'data:image/svg+xml;charset=utf-8,' +
      encodeURIComponent(`<svg xmlns='http://www.w3.org/2000/svg' width='300' height='300'>
        <defs><linearGradient id='g' x1='0' x2='1'><stop offset='0' stop-color='#efe6dc'/><stop offset='1' stop-color='#e5dbd0'/></linearGradient></defs>
        <rect width='100%' height='100%' rx='36' ry='36' fill='url(#g)'/>
        <text x='50%' y='52%' dominant-baseline='middle' text-anchor='middle' fill='#7a6f66' font-family='Arial' font-size='20'>Cover</text>
      </svg>`);

    const audio = playerRoot.querySelector('[data-xp-audio]');
    const coverEl = playerRoot.querySelector('[data-xp-cover]');
    const titleEl = playerRoot.querySelector('[data-xp-title]');
    const artistEl = playerRoot.querySelector('[data-xp-artist]');
    const listEl = playerRoot.querySelector('[data-xp-list]');
    const tabsEl = playerRoot.querySelector('[data-xp-tabs]');
    const countEl = playerRoot.querySelector('[data-xp-count]');
    const btnPrev = playerRoot.querySelector('[data-xp-prev]');
    const btnPlay = playerRoot.querySelector('[data-xp-play]');
    const btnNext = playerRoot.querySelector('[data-xp-next]');
    const btnRep = playerRoot.querySelector('[data-xp-repeat]');
    const playIcon = playerRoot.querySelector('[data-xp-play-icon]');
    const seek = playerRoot.querySelector('[data-xp-seek]');
    const curEl = playerRoot.querySelector('[data-xp-cur]');
    const durEl = playerRoot.querySelector('[data-xp-dur]');
    const volEl = playerRoot.querySelector('[data-xp-vol]');

    let style = null;
    let idx = -1;
    let loadedUrl = null;
    let seeking = false;
    let repeat = false;

    function tracks() {
      return style ? (DATA[style] || []) : [];
    }

    function current() {
      return idx >= 0 ? tracks()[idx] : null;
    }

    function fmt(sec) {
      if (!isFinite(sec)) return '0:00';
      sec = Math.max(0, Math.floor(sec));
      const m = Math.floor(sec / 60);
      const s = sec % 60;
      return `${m}:${String(s).padStart(2, '0')}`;
    }

    function setCover(src, alt) {
      coverEl.src = src || PLACEHOLDER;
      coverEl.alt = alt || 'Cover';
      coverEl.onerror = () => {
        coverEl.src = PLACEHOLDER;
        coverEl.onerror = null;
      };
    }

    function setPlayIcon(isPlaying) {
      playIcon.innerHTML = isPlaying
        ? '<path d="M6 5h4v14H6V5zm8 0h4v14h-4V5z"></path>'
        : '<path d="M8 5v14l11-7z"></path>';
    }

    function markCurrent() {
      [...listEl.querySelectorAll('.xp-track')].forEach((row, i) => {
        row.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
    }

    function unload() {
      audio.pause();
      audio.removeAttribute('src');
      audio.load();
      loadedUrl = null;
      seek.value = 0;
      curEl.textContent = '0:00';
      durEl.textContent = '0:00';
      setPlayIcon(false);
    }

    function ensureLoaded() {
      const t = current();
      if (!t) return false;
      if (loadedUrl !== t.url) {
        audio.src = t.url;
        loadedUrl = t.url;
      }
      return true;
    }

    async function play() {
      if (!ensureLoaded()) return;
      try {
        await audio.play();
        setPlayIcon(true);
      } catch (e) {}
    }

    function pause() {
      audio.pause();
      setPlayIcon(false);
    }

    function setNow(t) {
      if (!t) {
        titleEl.textContent = '—';
        artistEl.textContent = style ? `Stil: ${style}` : 'Wähle einen Stil';
        setCover(PLACEHOLDER, 'Cover');
        return;
      }

      titleEl.textContent = t.title || '—';
      artistEl.textContent = t.artist || (style || '');
      setCover(t.cover, t.title ? `Cover: ${t.title}` : 'Cover');
    }

    function selectTrack(newIdx, autoplay) {
      const list = tracks();
      if (!list.length) return;

      idx = Math.max(0, Math.min(newIdx, list.length - 1));
      setNow(current());
      markCurrent();
      unload();

      if (autoplay) play();
    }

    btnPlay.addEventListener('click', () => {
      if (!current()) {
        const list = tracks();
        if (!list.length) return;
        idx = 0;
        setNow(current());
        markCurrent();
      }

      if (audio.paused) play();
      else pause();
    });

    btnPrev.addEventListener('click', () => {
      if (idx <= 0) selectTrack(0, true);
      else selectTrack(idx - 1, true);
    });

    btnNext.addEventListener('click', () => {
      const list = tracks();
      if (!list.length) return;
      if (idx < list.length - 1) selectTrack(idx + 1, true);
      else selectTrack(list.length - 1, true);
    });

    btnRep.addEventListener('click', () => {
      repeat = !repeat;
      btnRep.classList.toggle('xp-repeat-on', repeat);
    });

    if (volEl) {
      audio.volume = parseFloat(volEl.value || '0.9');
      volEl.addEventListener('input', () => {
        audio.volume = parseFloat(volEl.value || '0.9');
      });
    }

    seek.addEventListener('input', () => {
      seeking = true;
      const d = audio.duration || 0;
      if (d > 0) {
        const v = parseFloat(seek.value) / 1000;
        curEl.textContent = fmt(v * d);
      }
    });

    seek.addEventListener('change', () => {
      const d = audio.duration || 0;
      if (d > 0) {
        const v = parseFloat(seek.value) / 1000;
        audio.currentTime = v * d;
      }
      seeking = false;
    });

    audio.addEventListener('timeupdate', () => {
      if (seeking) return;
      const d = audio.duration || 0;
      const t = audio.currentTime || 0;
      curEl.textContent = fmt(t);
      durEl.textContent = fmt(d);
      if (d > 0) seek.value = String(Math.round((t / d) * 1000));
    });

    audio.addEventListener('loadedmetadata', () => {
      durEl.textContent = fmt(audio.duration);
    });

    audio.addEventListener('play', () => setPlayIcon(true));
    audio.addEventListener('pause', () => setPlayIcon(false));

    audio.addEventListener('ended', () => {
      const list = tracks();
      if (repeat) {
        audio.currentTime = 0;
        audio.play().catch(() => {});
        return;
      }

      if (idx < list.length - 1) {
        selectTrack(idx + 1, true);
      } else {
        unload();
      }
    });

    const imgObserver = ('IntersectionObserver' in window)
      ? new IntersectionObserver((entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const img = entry.target;
            const real = img.dataset.src;
            if (real) {
              img.src = real;
              delete img.dataset.src;
            }
            obs.unobserve(img);
          });
        }, { rootMargin: '300px' })
      : null;

    function renderTabs() {
      const styles = Object.keys(DATA);
      tabsEl.innerHTML = '';

      styles.forEach((name, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'xp-tab';
        b.textContent = name;
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');

        b.addEventListener('click', () => {
          tabsEl.querySelectorAll('.xp-tab').forEach((x) => x.setAttribute('aria-selected', 'false'));
          b.setAttribute('aria-selected', 'true');
          style = name;
          idx = -1;
          setNow(null);
          unload();
          renderList();
        });

        tabsEl.appendChild(b);
      });

      if (styles.length) {
        style = styles[0];
        renderList();
      }
    }

    function renderList() {
      const list = tracks();
      listEl.innerHTML = '';
      countEl.textContent = list.length ? `${list.length} Beispiele` : 'Keine Beispiele';

      list.forEach((t, i) => {
        const row = document.createElement('button');
        row.type = 'button';
        row.className = 'xp-track';
        row.addEventListener('click', () => selectTrack(i, true));

        const img = document.createElement('img');
        img.className = 'xp-tcover';
        img.loading = 'lazy';
        img.decoding = 'async';
        img.src = PLACEHOLDER;
        img.dataset.src = t.cover || PLACEHOLDER;
        img.alt = t.title ? `Cover: ${t.title}` : 'Cover';
        img.onerror = () => {
          img.src = PLACEHOLDER;
          img.onerror = null;
        };

        if (imgObserver) imgObserver.observe(img);
        else img.src = img.dataset.src;

        const txt = document.createElement('div');

        const name = document.createElement('div');
        name.className = 'xp-tname';
        name.textContent = t.title || `Track ${i + 1}`;

        const meta = document.createElement('div');
        meta.className = 'xp-tmeta';
        meta.textContent = t.artist || style || '';

        txt.appendChild(name);
        txt.appendChild(meta);

        row.appendChild(img);
        row.appendChild(txt);
        listEl.appendChild(row);
      });

      if (list.length) {
        idx = 0;
        setNow(list[0]);
        markCurrent();
        unload();
      } else {
        idx = -1;
        setNow(null);
        unload();
      }

      btnRep.classList.toggle('xp-repeat-on', repeat);
    }

    setCover(PLACEHOLDER, 'Cover');
    setPlayIcon(false);
    renderTabs();
  }

  function openExampleModal() {
    if (!exampleModal) return;
    exampleModal.hidden = false;

    const innerDialog = exampleModal.querySelector('.product-personalizer__inner-dialog');
    if (innerDialog) innerDialog.scrollTop = 0;

    initExamplePlayer();
  }

  function closeExampleModal() {
    if (!exampleModal) return;

    const audio = exampleModal.querySelector('[data-xp-audio]');
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
    }

    exampleModal.hidden = true;
  }

  openBtns.forEach((btn) => {
    btn.addEventListener('click', openModal);
  });

  closeBtns.forEach((btn) => {
    btn.addEventListener('click', closeModal);
  });

  prevBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      showStep(1);
    });
  });

  exampleOpenBtn?.addEventListener('click', openExampleModal);

  exampleCloseBtns.forEach((btn) => {
    btn.addEventListener('click', closeExampleModal);
  });

  nextBtn?.addEventListener('click', () => {
    if (!collectStep1()) return;
    showStep(2);
  });

  submitBtn?.addEventListener('click', async () => {
    collectStep2();
    await addItemsToCartAndGoToCart();
  });

  root.querySelectorAll('select, input[type="radio"], input[type="date"]').forEach((field) => {
    field.addEventListener('change', () => {
      updateCardStates();
      updateWeddingDateVisibility();
      updatePhysicalVisibility();
      hideError();
    });
  });

  if (detailsField) {
    detailsField.addEventListener('input', () => {
      updateDetailsCounter();
      hideError();
    });
  }

  if (recipientField) {
    recipientField.addEventListener('input', () => {
      updateRecipientCounter();
      hideError();
    });
  }

  if (pronunciationField) {
    pronunciationField.addEventListener('input', () => {
      updatePronunciationCounter();
      hideError();
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    if (exampleModal && !exampleModal.hidden) {
      closeExampleModal();
      return;
    }

    if (modal && !modal.hidden) {
      closeModal();
    }
  });

  renderDeliveryDates();
  updateCardStates();
  updateWeddingDateVisibility();
  updatePhysicalVisibility();
  updateStepTitle(1);
  updateDetailsCounter();
  updateRecipientCounter();
  updatePronunciationCounter();
});